const onboardingRoutes = [
  {
    path: "/onboarding",
    name: "onboarding",
    component: () => import("@/modules/Esemente360/views/OnboardingHub.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Onboarding",
      onboardingHub: true,
      need_capability: "onboarding",
    },
  },
  {
    path: "/onboarding/produtos",
    name: "onboarding.products",
    component: () => import("@/modules/Esemente360/views/OnboardingProducts.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Cadastrar produtos",
      onboardingHub: true,
      need_capability: "onboarding",
    },
  },
  {
    path: "/onboarding/precos-estoque",
    name: "onboarding.priceStock",
    component: () => import("@/modules/Esemente360/views/OnboardingPriceStock.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Preços e estoque",
      onboardingHub: true,
      need_capability: "onboarding",
    },
  },
  // redirects das rotas antigas
  {
    path: "/onboarding/precos",
    redirect: { name: "onboarding.priceStock" },
  },
  {
    path: "/onboarding/estoque",
    redirect: { name: "onboarding.priceStock" },
  },
]

export default onboardingRoutes
